import { usuarioDispositivoService } from '../_services';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';
import { usuarioAction } from '../_actions/';

export const usuarioDispositivoAction = {
    getUsuarioDispositivo,
    enviaNotificacao,
    deleteDispositivoById,
    onChangeProps,
};

function getUsuarioDispositivo(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'usuariosDispositivos/' + id;
        usuarioDispositivoService.get(apiEndpoint)
            .then((response) => {
                dispatch(editUsuariosDispositivosDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                //console.log(err);
                //alerts.error(err);
            });
    };
}

function enviaNotificacao(showWaiting, payload) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'chamadas/gerar_notificacoes/dispositivo/';
        usuarioDispositivoService.post(apiEndpoint, payload)
            .then((response) => { 
                var ret = JSON.parse(response.request.responseText);
                dispatch(editUsuariosDispositivosDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
                alerts.success("Notificação enviada com sucesso!");

            }).catch((err) => {
                //console.log(err);
                //alerts.error(err);
            });
    };
}

function deleteDispositivoById(id, showWaiting, id_usuario) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir este dispositivo?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
            .then((willDelete) => {
                if (willDelete.value) {
                    let apiEndpoint = 'usuarioDispositivos/' + id;
                    usuarioDispositivoService.deleteDetail(apiEndpoint)
                        .then((response) => {
                            if (response.request.status === 200) {
                                var ret = JSON.parse(response.request.responseText);
                                dispatch(deleteUsuariosDispositivosDetails());
                                dispatch(usuarioAction.getUsuarioById(id_usuario, false))
                                if (showWaiting) {
                                    alerts.clean();
                                }
                                alerts.success(ret.message);
                            } else {
                                alerts.warning(response.request.responseText);
                            }
                        }).catch((err) => {
                            console.log(err.response);
                            return err.response;
                        })

                }
            });


    };
}

function onChangeProps(props, event) {
    return dispatch => {
        dispatch(handleOnChangeProps(props, event.target.value));
    }
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}

export function changeUsuariosDispositivosList(usuarioDispositivo) {
    return {
        type: "FETECHED_ALL_USUARIODISPOSITIVO",
        usuarioDispositivo: usuarioDispositivo
    }
}

export function createUserInfo() {
    return {
        type: "USUARIODISPOSITIVO_CREATED_SUCCESSFULLY"
    }
}

export function editUsuariosDispositivosDetails(usuarioDispositivo) {
    return {
        type: "USUARIODISPOSITIVO_DETAIL",
        id: usuarioDispositivo.id,
        id_fazenda: usuarioDispositivo.id_fazenda,
        token: usuarioDispositivo.token,
        marca: usuarioDispositivo.marca,
        modelo: usuarioDispositivo.modelo,
        data_ativacao: usuarioDispositivo.data_ativacao,
        sistema: usuarioDispositivo.sistema,
        excluido: usuarioDispositivo.excluido,
        id_usuario: usuarioDispositivo.id_usuario,
    }
}

export function deleteUsuariosDispositivosDetails() {
    return {
        type: "DELETED_USUARIODISPOSITIVO_DETAILS"
    }
}